// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productList_amount__UVjlh {
  width: 100%;
  height: 440px;
  background-color: var(--sb-bg-color);
  border-radius: 12px;
  margin-top: 16px;
  padding: 11px 20px 20px;
}
.productList_amount__UVjlh .productList_buttonClicked__Kamiu {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  font-size: 12px;
  background: linear-gradient(160.35deg, #ffa329 13.16%, #fe7b1c 42.24%, #fc2a01 71.32%);
  border: 1px solid #777778;
  border-radius: 15px;
  margin-right: 60px;
}
.productList_amount__UVjlh .productList_buttonNotClicked__iVC8l {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  background: var(--sb-bg-color);
  box-sizing: border-box;
  border: 1px solid #777778;
  border-radius: 10px;
  margin-right: 60px;
}
.productList_amount__UVjlh .productList_paymentMethod__kFb0Z span {
  width: 36px;
  height: 18px;
  font-weight: 700;
  font-family: Red Hat Display;
  font-size: 12px;
  color: var(--font-color);
  margin-left: 25px;
}
.productList_amount__UVjlh .productList_selectPlan__vlP3e {
  width: 100%;
  background-color: var(--hover-bg-color);
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 11px 20px 10px 16px;
  margin-top: 17px;
}
.productList_amount__UVjlh .productList_title__fKMSr {
  display: flex;
}
@media screen and (max-width: 781px) {
  .productList_amount__UVjlh .productList_title__fKMSr svg {
    width: 32px;
    height: 32px;
  }
}
.productList_amount__UVjlh .productList_title__fKMSr span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px;
  margin-left: 6px;
}
@media screen and (max-width: 781px) {
  .productList_amount__UVjlh .productList_title__fKMSr span {
    font-size: 18px;
    line-height: 30px;
  }
}
.productList_amount__UVjlh .productList_dataLabel__Y6fFv {
  display: flex;
  margin-top: 13px;
}
.productList_amount__UVjlh .productList_dataLabel__Y6fFv span {
  color: var(--re-from-color);
  text-align: right;
  font-family: Red Hat Display;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.productList_amount__UVjlh .productList_dataLabel__Y6fFv span:first-child {
  margin-left: 9px;
}
.productList_amount__UVjlh .productList_dataLabel__Y6fFv span:last-child {
  margin-left: auto;
}
.productList_amount__UVjlh .productList_price__xJ0JA {
  display: flex;
  margin-top: 3px;
}
.productList_amount__UVjlh .productList_price__xJ0JA span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.productList_amount__UVjlh .productList_price__xJ0JA span:first-child {
  margin-left: 9px;
}
.productList_amount__UVjlh .productList_price__xJ0JA span:last-child {
  margin-left: auto;
}
.productList_amount__UVjlh .productList_button__p9Yfl {
  width: 100%;
  display: flex;
  margin-top: 35px;
}
@media screen and (max-width: 781px) {
  .productList_amount__UVjlh .productList_button__p9Yfl button {
    height: 38px !important;
  }
}
.productList_amount__UVjlh .productList_button__p9Yfl button:last-child {
  margin-left: 11px;
}
.productList_amount__UVjlh .productList_button__p9Yfl img {
  top: 22%;
}

.productList_proxy_container__PaBn4 {
  width: 100%;
  border-top: none;
  margin-top: 16px;
  /* label btn*/
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-right: auto;
  /* label btn*/
}
.productList_proxy_container__PaBn4 .productList_freeDateLabel__AJ2-0 {
  padding: 2px 7px 2px 7px;
  color: #4ac46c;
  border-radius: 5px;
  background-color: var(--st-free-label-bg);
  font-size: 13px;
  text-decoration: none;
  text-align: center;
  display: inline-block;
}
.productList_proxy_container__PaBn4 .productList_expiredLabel__bXpXT {
  padding: 2px 11px 2px 12px;
  color: #e85454;
  border-radius: 5px;
  background-color: var(--st-expired-label-bg);
  font-size: 13px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
}
.productList_proxy_container__PaBn4 .productList_topUp__xN3Jd {
  color: white;
  background: linear-gradient(317.7deg, #ffa329 4.37%, #fe7b1c 44.1%, #fc2a01 115.53%), linear-gradient(90deg, #18c6eb 0%, #0a91b3 100%), linear-gradient(97.91deg, #fe82db 6.1%, #68e4ff 103.66%);
  padding: 3px 10px;
  border-radius: 9px;
  line-height: 17.2px;
  font-weight: 700;
  border: none;
  font-size: 15px;
  cursor: pointer;
}
.productList_proxy_container__PaBn4 .productList_buttons__Xj-Z5 {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 7px;
}
.productList_proxy_container__PaBn4 .productList_view__JuOk\\+ {
  color: var(--font-dark-color);
  background: var(--st-view-btn-bg);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  cursor: pointer;
}
.productList_proxy_container__PaBn4 .productList_reset__sn58y {
  color: var(--font-dark-color);
  background: var(--st-view-btn-bg);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  cursor: pointer;
}
.productList_proxy_container__PaBn4 .productList_download__dH\\+JE {
  color: var(--bg-color);
  background: var(--font-color);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}
.productList_proxy_container__PaBn4 .productList_proxy_option__LoU2q {
  width: 100%;
  display: flex;
  margin-top: 23px;
  margin-bottom: 15px;
}
.productList_proxy_container__PaBn4 .productList_proxy_option__LoU2q span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  margin-left: 10px;
  margin-right: auto;
}
.productList_proxy_container__PaBn4 .productList_proxy_option__LoU2q button {
  line-height: 16px !important;
}
.productList_proxy_container__PaBn4 .productList_proxy_option__LoU2q button svg {
  top: 35%;
}
.productList_proxy_container__PaBn4 .productList_proxy_option__LoU2q button:last-child {
  margin-left: 9px;
}
.productList_proxy_container__PaBn4 .productList_proxy_option__LoU2q button:last-child svg {
  top: 13%;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 800px;
  border-radius: 10px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA {
  display: none;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU {
  width: 100%;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW {
  width: 100%;
  padding: 13px 20px;
  margin-bottom: 11px;
  border-radius: 10px;
  border: 1px solid var(--re-mobile-title-border-bg);
  background-color: var(--bg-color);
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_product_head__1M8eI {
  position: relative;
  margin-bottom: 30px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_product_head__1M8eI .productList_product_headLabel__CY5qz {
  color: #ffa329;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_product_head__1M8eI .productList_product_name__E-y0X {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_product_head__1M8eI .productList_quantity__WSDh0 {
  color: var(--font-dark-color);
  font-weight: 700;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_product_head__1M8eI .productList_quantity_No__jaWZI {
  color: var(--font-color);
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_product_head__1M8eI .productList_right__xf0it {
  float: right;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_product_head__1M8eI .productList_day_label__BCUhr {
  font-size: 12px;
  position: absolute;
  top: -17px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_product_head__1M8eI .productList_expired_label__HaArR {
  font-size: 12px;
  position: absolute;
  top: -17px;
  right: 0;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_product_head__1M8eI .productList_white__bBGy3 {
  color: var(--font-color);
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_product_head__1M8eI .productList_marginRight__85OZP {
  margin-right: 6px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_day__Zv3Ms {
  position: relative;
  margin-bottom: 36px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA .productList_productCardContainer__hviYU .productList_productCard__E55pW .productList_location__0\\+9v5 {
  position: relative;
  margin-bottom: 16px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_Data__-qICP {
  font-family: Red Hat Display;
  color: #ffffff;
  font-weight: 700;
  line-height: 19.85px;
  font-size: 15px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_LowData__Nf4MZ {
  font-family: Red Hat Display;
  color: #e85454;
  font-weight: 700;
  line-height: 19.85px;
  font-size: 15px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_HighData__O1oJ9 {
  font-family: Red Hat Display;
  color: #4ac46c;
  font-weight: 700;
  line-height: 19.85px;
  font-size: 15px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_ProductName__v3oPR {
  font-family: Red Hat Display;
  color: #ffa329;
  font-weight: 700;
  line-height: 19.85px;
  font-size: 15px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_ProductType__CfYO9 {
  font-family: Red Hat Display;
  color: #0ae7d3;
  font-weight: 700;
  line-height: 19.85px;
  font-size: 15px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX {
  width: 100%;
  border: 1px solid var(--re-border-color);
  border-radius: 10px;
  display: flex;
  margin-bottom: 10px;
  padding: 8px 7px;
  text-align: left;
  align-items: center;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX th,
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX td {
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-right: auto;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX th .productList_freeDateLabel__AJ2-0,
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX td .productList_freeDateLabel__AJ2-0 {
  padding: 2px 7px 2px 7px;
  color: #4ac46c;
  border-radius: 5px;
  background-color: var(--st-free-label-bg);
  font-size: 13px;
  text-decoration: none;
  text-align: center;
  display: inline-block;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX th .productList_expiredLabel__bXpXT,
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX td .productList_expiredLabel__bXpXT {
  padding: 2px 11px 2px 12px;
  color: #e85454;
  border-radius: 5px;
  background-color: var(--st-expired-label-bg);
  font-size: 13px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX th .productList_view__JuOk\\+,
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX td .productList_view__JuOk\\+ {
  color: var(--font-dark-color);
  background: var(--st-view-btn-bg);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  cursor: pointer;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX th .productList_download__dH\\+JE,
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX td .productList_download__dH\\+JE {
  color: var(--bg-color);
  background: var(--font-color);
  padding: 3px 10px;
  border-radius: 9px;
  border: none;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy__3RMCX img {
  cursor: pointer;
}
@media screen and (max-width: 781px) {
  .productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_proxy_ref__EKAJd {
    display: none;
  }
  .productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_desktop__qvw\\+E {
    display: none;
  }
  .productList_proxy_container__PaBn4 .productList_proxy_list__co6-B .productList_mobile__yzJEA {
    display: block;
  }
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B::-webkit-scrollbar {
  width: 2px;
  height: 7px;
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B::-webkit-scrollbar-thumb {
  background: linear-gradient(316deg, #ffa329 4.43%, #fe7b1c 56.59%, #fc2a01 150.36%);
}
.productList_proxy_container__PaBn4 .productList_proxy_list__co6-B::-webkit-scrollbar-track {
  background-color: var(--bg-color);
}

.productList_proxy_container__PaBn4::-webkit-scrollbar {
  width: 2px;
  height: 7px;
}

.productList_proxy_container__PaBn4::-webkit-scrollbar-thumb {
  background: linear-gradient(316deg, #ffa329 4.43%, #fe7b1c 56.59%, #fc2a01 150.36%);
}

.productList_proxy_container__PaBn4::-webkit-scrollbar-track {
  background-color: var(--bg-color);
}

.productList_container__Dm7YI {
  width: 100%;
  height: 100%;
  border: 1px solid var(--sb-border-color);
  border-top: none;
  padding: 18px 24px 0 26px;
}
.productList_container__Dm7YI .productList_selectPlan__vlP3e {
  width: 100%;
  background-color: var(--re-select-dark-bg);
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 11px 20px 10px 16px;
  margin-top: 17px;
}
@media (max-width: 1850px) {
  .productList_container__Dm7YI {
    padding: 11px 10px 0 10px;
  }
}
@media (max-width: 781px) {
  .productList_container__Dm7YI {
    padding: 11px 14px 0 14px;
  }
}
.productList_container__Dm7YI .productList_brand__DLBrJ {
  display: flex;
}
.productList_container__Dm7YI .productList_brand__DLBrJ svg {
  width: 36px;
  height: 36px;
}
.productList_container__Dm7YI .productList_brand__DLBrJ span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
  margin-left: 6px;
}
@media (max-width: 781px) {
  .productList_container__Dm7YI .productList_brand__DLBrJ span {
    font-size: 16px;
  }
}
.productList_container__Dm7YI select {
  margin-top: 10px;
}
@media (max-width: 781px) {
  .productList_container__Dm7YI select {
    height: 42px;
  }
}
.productList_container__Dm7YI .productList_lab__euy7q {
  width: 100%;
  height: 320px;
  max-height: 320px;
  min-height: 320px;
  border: 1px solid var(--re-border-color);
  border-radius: 12px;
  padding: 20px 20px 23px 20px;
  position: relative;
  margin-top: 13px;
}
@media screen and (max-width: 1600px) {
  .productList_container__Dm7YI .productList_lab__euy7q {
    padding: 20px 10px 23px 10px;
  }
}
@media screen and (max-width: 781px) {
  .productList_container__Dm7YI .productList_lab__euy7q {
    padding: 16px 20px 23px 20px;
    height: 270px;
  }
}
.productList_container__Dm7YI .productList_lab__euy7q span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 781px) {
  .productList_container__Dm7YI .productList_lab__euy7q span {
    font-size: 24px;
  }
}
.productList_container__Dm7YI .productList_lab__euy7q .productList_labList__JZkHf {
  width: 100%;
  height: 160px;
  max-height: 160px;
  min-height: 160px;
  margin-top: 16px;
  overflow-y: hidden;
  overflow-x: hidden;
}
@media screen and (max-width: 781px) {
  .productList_container__Dm7YI .productList_lab__euy7q .productList_labList__JZkHf {
    margin-top: 8px;
  }
}
.productList_container__Dm7YI .productList_lab__euy7q .productList_labList__JZkHf .productList_labItem__F4KV1 {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.productList_container__Dm7YI .productList_lab__euy7q .productList_labList__JZkHf .productList_labItem__F4KV1 .productList_moreItemText__ego2g {
  margin-left: 7px;
}
.productList_container__Dm7YI .productList_lab__euy7q .productList_labList__JZkHf::-webkit-scrollbar,
.productList_container__Dm7YI .productList_lab__euy7q ::-webkit-scrollbar-thumb,
.productList_container__Dm7YI .productList_lab__euy7q ::-webkit-scrollbar-track {
  background-color: var(--bg-color);
}
.productList_container__Dm7YI .productList_lab__euy7q .productList_from__FwZiQ {
  color: var(--re-from-color);
  font-family: Red Hat Display;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 15px;
}
.productList_container__Dm7YI .productList_lab__euy7q .productList_labInfo__tGITV {
  min-width: 100%;
  max-width: 100%;
  display: flex;
  margin-top: 2px;
}
.productList_container__Dm7YI .productList_lab__euy7q .productList_labInfo__tGITV span {
  margin-right: auto;
}
.productList_container__Dm7YI .productList_lab__euy7q .productList_labInfo__tGITV button {
  line-height: 16px;
}
.productList_container__Dm7YI .productList_lab__euy7q .productList_labInfo__tGITV button svg {
  top: 36%;
}
.productList_container__Dm7YI .productList_lab__euy7q .productList_logo__0tvQf {
  width: 38px;
  height: 38px;
  position: absolute;
  top: 17px;
  right: 24px;
}
.productList_container__Dm7YI .productList_amount__UVjlh {
  width: 100%;
  height: 310px;
  background-color: var(--sb-bg-color);
  border-radius: 12px;
  margin-top: 16px;
  padding: 11px 20px 20px;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_title__fKMSr {
  display: flex;
}
@media screen and (max-width: 781px) {
  .productList_container__Dm7YI .productList_amount__UVjlh .productList_title__fKMSr svg {
    width: 32px;
    height: 32px;
  }
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_title__fKMSr span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px;
  margin-left: 6px;
}
@media screen and (max-width: 781px) {
  .productList_container__Dm7YI .productList_amount__UVjlh .productList_title__fKMSr span {
    font-size: 18px;
    line-height: 30px;
  }
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_buttonClicked__Kamiu {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  font-size: 12px;
  background: linear-gradient(160.35deg, #ffa329 13.16%, #fe7b1c 42.24%, #fc2a01 71.32%);
  border: 1px solid #777778;
  border-radius: 15px;
  margin-right: 60px;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_buttonNotClicked__iVC8l {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  background: var(--sb-bg-color);
  box-sizing: border-box;
  border: 1px solid #777778;
  border-radius: 10px;
  margin-right: 60px;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_paymentMethod__kFb0Z span {
  width: 36px;
  height: 18px;
  font-weight: 700;
  font-family: Red Hat Display;
  font-size: 12px;
  color: var(--font-color);
  margin-left: 25px;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_paymentLabel__zFX7g {
  display: flex;
  margin-top: 13px;
  color: white;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_paymentLabel__zFX7g span {
  color: var(--re-from-color);
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_dataLabel__Y6fFv {
  display: flex;
  margin-top: 15px;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_dataLabel__Y6fFv span {
  color: var(--re-from-color);
  text-align: right;
  font-family: Red Hat Display;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_dataLabel__Y6fFv span:first-child {
  margin-left: 9px;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_dataLabel__Y6fFv span:last-child {
  margin-left: auto;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_price__xJ0JA {
  display: flex;
  margin-top: 3px;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_price__xJ0JA span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_price__xJ0JA span:first-child {
  margin-left: 9px;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_price__xJ0JA span:last-child {
  margin-left: auto;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_button__p9Yfl {
  width: 100%;
  display: flex;
  margin-top: 14px;
}
@media screen and (max-width: 781px) {
  .productList_container__Dm7YI .productList_amount__UVjlh .productList_button__p9Yfl button {
    height: 38px !important;
  }
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_button__p9Yfl button:last-child {
  margin-left: 11px;
}
.productList_container__Dm7YI .productList_amount__UVjlh .productList_button__p9Yfl img {
  top: 22%;
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/hybrid-products/productList.module.scss"],"names":[],"mappings":"AAAA;EAwCE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtCF;AANE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sFAAA;EAMA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAGJ;AAAE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;AAAN;AAWE;EACE,WAAA;EACA,uCAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AATJ;AAYE;EACE,aAAA;AAVJ;AAYI;EACE;IACE,WAAA;IACA,YAAA;EAVN;AACF;AAaI;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAXN;AAaM;EATF;IAUI,eAAA;IACA,iBAAA;EAVN;AACF;AAcE;EACE,aAAA;EACA,gBAAA;AAZJ;AAcI;EACE,2BAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAZN;AAeI;EACE,gBAAA;AAbN;AAgBI;EACE,iBAAA;AAdN;AAkBE;EACE,aAAA;EACA,eAAA;AAhBJ;AAkBI;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,gBAAA;AAjBN;AAoBI;EACE,iBAAA;AAlBN;AAsBE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AApBJ;AAsBI;EACE;IACE,uBAAA;EApBN;AACF;AAuBI;EACE,iBAAA;AArBN;AAwBI;EACE,QAAA;AAtBN;;AA2BA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EAEA,aAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EAmFA,aAAA;AA3GF;AA0BE;EACE,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AAxBJ;AA2BE;EACE,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,4CAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;AAzBJ;AA4BE;EACE,YAAA;EACA,gMAAA;EAQA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EAEA,eAAA;AAlCJ;AAqCE;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,QAAA;AAnCJ;AAsCE;EACE,6BAAA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EAEA,eAAA;AArCJ;AAwCE;EACE,6BAAA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAtCJ;AAyCE;EACE,sBAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAvCJ;AA4CE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AA1CJ;AA4CI;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AA1CN;AA6CI;EACE,4BAAA;AA3CN;AA6CM;EACE,QAAA;AA3CR;AA+CI;EACE,gBAAA;AA7CN;AA+CM;EACE,QAAA;AA7CR;AAkDE;EACE,gBAAA;EAGA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAlDJ;AAoDI;EACE,aAAA;AAlDN;AAmDM;EACE,WAAA;AAjDR;AAmDQ;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kDAAA;EACA,iCAAA;AAjDV;AAmDU;EACE,kBAAA;EACA,mBAAA;AAjDZ;AAmDY;EACE,cAAA;AAjDd;AAoDY;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlDd;AAqDY;EACE,6BAAA;EACA,gBAAA;AAnDd;AAsDY;EACE,wBAAA;AApDd;AAuDY;EACE,YAAA;AArDd;AAwDY;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AAtDd;AAyDY;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAvDd;AA0DY;EACE,wBAAA;AAxDd;AA2DY;EACE,iBAAA;AAzDd;AA6DU;EACE,kBAAA;EACA,mBAAA;AA3DZ;AA8DU;EACE,kBAAA;EACA,mBAAA;AA5DZ;AAkEI;EACE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAhEN;AAmEI;EACE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAjEN;AAoEI;EACE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAlEN;AAqEI;EACE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAnEN;AAsEI;EACE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AApEN;AAuEI;EACE,WAAA;EAEA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAtEN;AAwEM;;EAEE,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAtER;AAwEQ;;EACE,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AArEV;AAwEQ;;EACE,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,4CAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;AArEV;AAwEQ;;EACE,6BAAA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EAEA,eAAA;AAtEV;AAyEQ;;EACE,sBAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAtEV;AA0EM;EACE,eAAA;AAxER;AA4EI;EACE;IACE,aAAA;EA1EN;EA6EI;IACE,aAAA;EA3EN;EA8EI;IACE,cAAA;EA5EN;AACF;AAgFE;EACE,UAAA;EACA,WAAA;AA9EJ;AAiFE;EACE,mFAAA;AA/EJ;AAuFE;EACE,iCAAA;AArFJ;;AAyFA;EACE,UAAA;EACA,WAAA;AAtFF;;AAyFA;EACE,mFAAA;AAtFF;;AA8FA;EACE,iCAAA;AA3FF;;AA8FA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;EACA,yBAAA;AA3FF;AA6FE;EACE,WAAA;EACA,0CAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AA3FJ;AA8FE;EAtBF;IAuBI,yBAAA;EA3FF;AACF;AA6FE;EA1BF;IA2BI,yBAAA;EA1FF;AACF;AA4FE;EACE,aAAA;AA1FJ;AA4FI;EACE,WAAA;EACA,YAAA;AA1FN;AA6FI;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AA3FN;AA6FM;EATF;IAUI,eAAA;EA1FN;AACF;AA8FE;EACE,gBAAA;AA5FJ;AA8FI;EAHF;IAII,YAAA;EA3FJ;AACF;AA8FE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,wCAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AA5FJ;AA8FI;EAXF;IAYI,4BAAA;EA3FJ;AACF;AA6FI;EAfF;IAgBI,4BAAA;IACA,aAAA;EA1FJ;AACF;AA4FI;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA1FN;AA4FM;EARF;IASI,eAAA;EAzFN;AACF;AA4FI;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA1FN;AA4FM;EATF;IAUI,eAAA;EAzFN;AACF;AA2FM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAzFR;AA2FQ;EACE,gBAAA;AAzFV;AA8FI;;;EAGE,iCAAA;AA5FN;AA+FI;EACE,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA7FN;AAgGI;EACE,eAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AA9FN;AAgGM;EACE,kBAAA;AA9FR;AAiGM;EACE,iBAAA;AA/FR;AAiGQ;EACE,QAAA;AA/FV;AAoGI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAlGN;AAsGE;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AApGJ;AAsGI;EACE,aAAA;AApGN;AAsGM;EACE;IACE,WAAA;IACA,YAAA;EApGR;AACF;AAuGM;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AArGR;AAuGQ;EATF;IAUI,eAAA;IACA,iBAAA;EApGR;AACF;AAwGI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sFAAA;EAMA,yBAAA;EACA,mBAAA;EACA,kBAAA;AA3GN;AA8GI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AA5GN;AAgHM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;AA9GR;AAkHI;EACE,aAAA;EACA,gBAAA;EACA,YAAA;AAhHN;AAkHM;EACE,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhHR;AAoHI;EACE,aAAA;EACA,gBAAA;AAlHN;AAoHM;EACE,2BAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlHR;AAqHM;EACE,gBAAA;AAnHR;AAsHM;EACE,iBAAA;AApHR;AAwHI;EACE,aAAA;EACA,eAAA;AAtHN;AAwHM;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtHR;AAyHM;EACE,gBAAA;AAvHR;AA0HM;EACE,iBAAA;AAxHR;AA4HI;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AA1HN;AA4HM;EACE;IACE,uBAAA;EA1HR;AACF;AA6HM;EACE,iBAAA;AA3HR;AA8HM;EACE,QAAA;AA5HR","sourcesContent":[".amount {\n  .buttonClicked {\n    width: 20px;\n    height: 20px;\n    margin-top: 10px;\n    font-size: 12px;\n    background: linear-gradient(\n      160.35deg,\n      #ffa329 13.16%,\n      #fe7b1c 42.24%,\n      #fc2a01 71.32%\n    );\n    border: 1px solid #777778;\n    border-radius: 15px;\n    margin-right: 60px;\n  }\n\n  .buttonNotClicked {\n    width: 20px;\n    height: 20px;\n    margin-top: 10px;\n    background: var(--sb-bg-color);\n    box-sizing: border-box;\n    border: 1px solid #777778;\n    border-radius: 10px;\n    margin-right: 60px;\n  }\n\n  .paymentMethod {\n    span {\n      width: 36px;\n      height: 18px;\n      font-weight: 700;\n      font-family: Red Hat Display;\n      font-size: 12px;\n      color: var(--font-color);\n      margin-left: 25px;\n    }\n  }\n\n  width: 100%;\n  height: 440px;\n  background-color: var(--sb-bg-color);\n  border-radius: 12px;\n  margin-top: 16px;\n  padding: 11px 20px 20px;\n\n  .selectPlan {\n    width: 100%;\n    background-color: var(--hover-bg-color);\n    border-radius: 12px;\n    border: 1px solid transparent;\n    color: var(--font-dark-color);\n    font-family: Red Hat Display;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    padding: 11px 20px 10px 16px;\n    margin-top: 17px;\n  }\n\n  .title {\n    display: flex;\n\n    @media screen and (max-width: 781px) {\n      svg {\n        width: 32px;\n        height: 32px;\n      }\n    }\n\n    span {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 39px;\n      margin-left: 6px;\n\n      @media screen and (max-width: 781px) {\n        font-size: 18px;\n        line-height: 30px;\n      }\n    }\n  }\n\n  .dataLabel {\n    display: flex;\n    margin-top: 13px;\n\n    span {\n      color: var(--re-from-color);\n      text-align: right;\n      font-family: Red Hat Display;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n\n    span:first-child {\n      margin-left: 9px;\n    }\n\n    span:last-child {\n      margin-left: auto;\n    }\n  }\n\n  .price {\n    display: flex;\n    margin-top: 3px;\n\n    span {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    span:first-child {\n      margin-left: 9px;\n    }\n\n    span:last-child {\n      margin-left: auto;\n    }\n  }\n\n  .button {\n    width: 100%;\n    display: flex;\n    margin-top: 35px;\n\n    @media screen and (max-width: 781px) {\n      button {\n        height: 38px !important;\n      }\n    }\n\n    button:last-child {\n      margin-left: 11px;\n    }\n\n    img {\n      top: 22%;\n    }\n  }\n}\n\n.proxy_container {\n  width: 100%;\n  border-top: none;\n  margin-top: 16px;\n\n  /* label btn*/\n  color: var(--font-dark-color);\n  font-family: Red Hat Display;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin-right: auto;\n\n  .freeDateLabel {\n    padding: 2px 7px 2px 7px;\n    color: #4ac46c;\n    border-radius: 5px;\n    background-color: var(--st-free-label-bg);\n    font-size: 13px;\n    text-decoration: none;\n    text-align: center;\n    display: inline-block;\n  }\n\n  .expiredLabel {\n    padding: 2px 11px 2px 12px;\n    color: #e85454;\n    border-radius: 5px;\n    background-color: var(--st-expired-label-bg);\n    font-size: 13px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n  }\n\n  .topUp {\n    color: white;\n    background: linear-gradient(\n        317.7deg,\n        #ffa329 4.37%,\n        #fe7b1c 44.1%,\n        #fc2a01 115.53%\n      ),\n      linear-gradient(90deg, #18c6eb 0%, #0a91b3 100%),\n      linear-gradient(97.91deg, #fe82db 6.1%, #68e4ff 103.66%);\n    padding: 3px 10px;\n    border-radius: 9px;\n    line-height: 17.2px;\n    font-weight: 700;\n    border: none;\n    font-size: 15px;\n    // font-weight: 700;\n    cursor: pointer;\n  }\n\n  .buttons {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    gap: 7px;\n  }\n\n  .view {\n    color: var(--font-dark-color);\n    background: var(--st-view-btn-bg);\n    padding: 3px 10px;\n    border-radius: 9px;\n    border: none;\n    font-size: 15px;\n    // font-weight: 700;\n    cursor: pointer;\n  }\n\n  .reset {\n    color: var(--font-dark-color);\n    background: var(--st-view-btn-bg);\n    padding: 3px 10px;\n    border-radius: 9px;\n    border: none;\n    font-size: 15px;\n    cursor: pointer;\n  }\n\n  .download {\n    color: var(--bg-color);\n    background: var(--font-color);\n    padding: 3px 10px;\n    border-radius: 9px;\n    border: none;\n    font-size: 15px;\n    font-weight: 700;\n    cursor: pointer;\n  }\n\n  /* label btn*/\n\n  .proxy_option {\n    width: 100%;\n    display: flex;\n    margin-top: 23px;\n    margin-bottom: 15px;\n\n    span {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 36px;\n      margin-left: 10px;\n      margin-right: auto;\n    }\n\n    button {\n      line-height: 16px !important;\n\n      svg {\n        top: 35%;\n      }\n    }\n\n    button:last-child {\n      margin-left: 9px;\n\n      svg {\n        top: 13%;\n      }\n    }\n  }\n\n  .proxy_list {\n    overflow-y: auto;\n    // min-width: 1300px;\n    // overflow-x: auto;\n    overflow-x: hidden;\n    max-height: 800px;\n    border-radius: 10px;\n\n    .mobile {\n      display: none;\n      .productCardContainer {\n        width: 100%;\n\n        .productCard {\n          width: 100%;\n          padding: 13px 20px;\n          margin-bottom: 11px;\n          border-radius: 10px;\n          border: 1px solid var(--re-mobile-title-border-bg);\n          background-color: var(--bg-color);\n\n          .product_head {\n            position: relative;\n            margin-bottom: 30px;\n\n            .product_headLabel {\n              color: #ffa329;\n            }\n\n            .product_name {\n              color: var(--font-color);\n              font-family: Red Hat Display;\n              font-size: 15px;\n              font-style: normal;\n              font-weight: 700;\n              line-height: normal;\n            }\n\n            .quantity {\n              color: var(--font-dark-color);\n              font-weight: 700;\n            }\n\n            .quantity_No {\n              color: var(--font-color);\n            }\n\n            .right {\n              float: right;\n            }\n\n            .day_label {\n              font-size: 12px;\n              position: absolute;\n              top: -17px;\n            }\n\n            .expired_label {\n              font-size: 12px;\n              position: absolute;\n              top: -17px;\n              right: 0;\n            }\n\n            .white {\n              color: var(--font-color);\n            }\n\n            .marginRight {\n              margin-right: 6px;\n            }\n          }\n\n          .day {\n            position: relative;\n            margin-bottom: 36px;\n          }\n\n          .location {\n            position: relative;\n            margin-bottom: 16px;\n          }\n        }\n      }\n    }\n\n    .Data {\n      font-family: Red Hat Display;\n      color: #ffffff;\n      font-weight: 700;\n      line-height: 19.85px;\n      font-size: 15px;\n    }\n\n    .LowData {\n      font-family: Red Hat Display;\n      color: #e85454;\n      font-weight: 700;\n      line-height: 19.85px;\n      font-size: 15px;\n    }\n\n    .HighData {\n      font-family: Red Hat Display;\n      color: #4ac46c;\n      font-weight: 700;\n      line-height: 19.85px;\n      font-size: 15px;\n    }\n\n    .ProductName {\n      font-family: Red Hat Display;\n      color: #ffa329;\n      font-weight: 700;\n      line-height: 19.85px;\n      font-size: 15px;\n    }\n\n    .ProductType {\n      font-family: Red Hat Display;\n      color: #0ae7d3;\n      font-weight: 700;\n      line-height: 19.85px;\n      font-size: 15px;\n    }\n\n    .proxy {\n      width: 100%;\n      // height: 38px;\n      border: 1px solid var(--re-border-color);\n      border-radius: 10px;\n      display: flex;\n      margin-bottom: 10px;\n      padding: 8px 7px;\n      text-align: left;\n      align-items: center;\n\n      th,\n      td {\n        color: var(--font-dark-color);\n        font-family: Red Hat Display;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        margin-right: auto;\n\n        .freeDateLabel {\n          padding: 2px 7px 2px 7px;\n          color: #4ac46c;\n          border-radius: 5px;\n          background-color: var(--st-free-label-bg);\n          font-size: 13px;\n          text-decoration: none;\n          text-align: center;\n          display: inline-block;\n        }\n\n        .expiredLabel {\n          padding: 2px 11px 2px 12px;\n          color: #e85454;\n          border-radius: 5px;\n          background-color: var(--st-expired-label-bg);\n          font-size: 13px;\n          text-align: center;\n          text-decoration: none;\n          display: inline-block;\n        }\n\n        .view {\n          color: var(--font-dark-color);\n          background: var(--st-view-btn-bg);\n          padding: 3px 10px;\n          border-radius: 9px;\n          border: none;\n          font-size: 15px;\n          // font-weight: 700;\n          cursor: pointer;\n        }\n\n        .download {\n          color: var(--bg-color);\n          background: var(--font-color);\n          padding: 3px 10px;\n          border-radius: 9px;\n          border: none;\n          font-size: 15px;\n          font-weight: 700;\n          cursor: pointer;\n        }\n      }\n\n      img {\n        cursor: pointer;\n      }\n    }\n\n    @media screen and (max-width: 781px) {\n      .proxy_ref {\n        display: none;\n      }\n\n      .desktop {\n        display: none;\n      }\n\n      .mobile {\n        display: block;\n      }\n    }\n  }\n\n  .proxy_list::-webkit-scrollbar {\n    width: 2px;\n    height: 7px;\n  }\n\n  .proxy_list::-webkit-scrollbar-thumb {\n    background: linear-gradient(\n      316deg,\n      #ffa329 4.43%,\n      #fe7b1c 56.59%,\n      #fc2a01 150.36%\n    );\n  }\n\n  .proxy_list::-webkit-scrollbar-track {\n    background-color: var(--bg-color);\n  }\n}\n\n.proxy_container::-webkit-scrollbar {\n  width: 2px;\n  height: 7px;\n}\n\n.proxy_container::-webkit-scrollbar-thumb {\n  background: linear-gradient(\n    316deg,\n    #ffa329 4.43%,\n    #fe7b1c 56.59%,\n    #fc2a01 150.36%\n  );\n}\n\n.proxy_container::-webkit-scrollbar-track {\n  background-color: var(--bg-color);\n}\n\n.container {\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--sb-border-color);\n  border-top: none;\n  padding: 18px 24px 0 26px;\n\n  .selectPlan {\n    width: 100%;\n    background-color: var(--re-select-dark-bg);\n    border-radius: 12px;\n    border: 1px solid transparent;\n    color: var(--font-dark-color);\n    font-family: Red Hat Display;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    padding: 11px 20px 10px 16px;\n    margin-top: 17px;\n  }\n\n  @media (max-width: 1850px) {\n    padding: 11px 10px 0 10px;\n  }\n\n  @media (max-width: 781px) {\n    padding: 11px 14px 0 14px;\n  }\n\n  .brand {\n    display: flex;\n\n    svg {\n      width: 36px;\n      height: 36px;\n    }\n\n    span {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 38px;\n      margin-left: 6px;\n\n      @media (max-width: 781px) {\n        font-size: 16px;\n      }\n    }\n  }\n\n  select {\n    margin-top: 10px;\n\n    @media (max-width: 781px) {\n      height: 42px;\n    }\n  }\n\n  .lab {\n    width: 100%;\n    height: 320px;\n    max-height: 320px;\n    min-height: 320px;\n    border: 1px solid var(--re-border-color);\n    border-radius: 12px;\n    padding: 20px 20px 23px 20px;\n    position: relative;\n    margin-top: 13px;\n\n    @media screen and (max-width: 1600px) {\n      padding: 20px 10px 23px 10px;\n    }\n\n    @media screen and (max-width: 781px) {\n      padding: 16px 20px 23px 20px;\n      height: 270px;\n    }\n\n    span {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n\n      @media screen and (max-width: 781px) {\n        font-size: 24px;\n      }\n    }\n\n    .labList {\n      width: 100%;\n      height: 160px;\n      max-height: 160px;\n      min-height: 160px;\n      margin-top: 16px;\n      overflow-y: hidden;\n      overflow-x: hidden;\n\n      @media screen and (max-width: 781px) {\n        margin-top: 8px;\n      }\n\n      .labItem {\n        display: flex;\n        align-items: flex-start;\n        margin-bottom: 12px;\n\n        .moreItemText {\n          margin-left: 7px;\n        }\n      }\n    }\n\n    .labList::-webkit-scrollbar,\n    ::-webkit-scrollbar-thumb,\n    ::-webkit-scrollbar-track {\n      background-color: var(--bg-color);\n    }\n\n    .from {\n      color: var(--re-from-color);\n      font-family: Red Hat Display;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      margin-top: 15px;\n    }\n\n    .labInfo {\n      min-width: 100%;\n      max-width: 100%;\n      display: flex;\n      margin-top: 2px;\n\n      span {\n        margin-right: auto;\n      }\n\n      button {\n        line-height: 16px;\n\n        svg {\n          top: 36%;\n        }\n      }\n    }\n\n    .logo {\n      width: 38px;\n      height: 38px;\n      position: absolute;\n      top: 17px;\n      right: 24px;\n    }\n  }\n\n  .amount {\n    width: 100%;\n    height: 310px;\n    background-color: var(--sb-bg-color);\n    border-radius: 12px;\n    margin-top: 16px;\n    padding: 11px 20px 20px;\n\n    .title {\n      display: flex;\n\n      @media screen and (max-width: 781px) {\n        svg {\n          width: 32px;\n          height: 32px;\n        }\n      }\n\n      span {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 39px;\n        margin-left: 6px;\n\n        @media screen and (max-width: 781px) {\n          font-size: 18px;\n          line-height: 30px;\n        }\n      }\n    }\n\n    .buttonClicked {\n      width: 20px;\n      height: 20px;\n      margin-top: 10px;\n      font-size: 12px;\n      background: linear-gradient(\n        160.35deg,\n        #ffa329 13.16%,\n        #fe7b1c 42.24%,\n        #fc2a01 71.32%\n      );\n      border: 1px solid #777778;\n      border-radius: 15px;\n      margin-right: 60px;\n    }\n\n    .buttonNotClicked {\n      width: 20px;\n      height: 20px;\n      margin-top: 10px;\n      background: var(--sb-bg-color);\n      box-sizing: border-box;\n      border: 1px solid #777778;\n      border-radius: 10px;\n      margin-right: 60px;\n    }\n\n    .paymentMethod {\n      span {\n        width: 36px;\n        height: 18px;\n        font-weight: 700;\n        font-family: Red Hat Display;\n        font-size: 12px;\n        color: var(--font-color);\n        margin-left: 25px;\n      }\n    }\n\n    .paymentLabel {\n      display: flex;\n      margin-top: 13px;\n      color: white;\n\n      span {\n        color: var(--re-from-color);\n        font-family: Red Hat Display;\n        font-size: 15px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n      }\n    }\n\n    .dataLabel {\n      display: flex;\n      margin-top: 15px;\n\n      span {\n        color: var(--re-from-color);\n        text-align: right;\n        font-family: Red Hat Display;\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n      }\n\n      span:first-child {\n        margin-left: 9px;\n      }\n\n      span:last-child {\n        margin-left: auto;\n      }\n    }\n\n    .price {\n      display: flex;\n      margin-top: 3px;\n\n      span {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n      }\n\n      span:first-child {\n        margin-left: 9px;\n      }\n\n      span:last-child {\n        margin-left: auto;\n      }\n    }\n\n    .button {\n      width: 100%;\n      display: flex;\n      margin-top: 14px;\n\n      @media screen and (max-width: 781px) {\n        button {\n          height: 38px !important;\n        }\n      }\n\n      button:last-child {\n        margin-left: 11px;\n      }\n\n      img {\n        top: 22%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"amount": `productList_amount__UVjlh`,
	"buttonClicked": `productList_buttonClicked__Kamiu`,
	"buttonNotClicked": `productList_buttonNotClicked__iVC8l`,
	"paymentMethod": `productList_paymentMethod__kFb0Z`,
	"selectPlan": `productList_selectPlan__vlP3e`,
	"title": `productList_title__fKMSr`,
	"dataLabel": `productList_dataLabel__Y6fFv`,
	"price": `productList_price__xJ0JA`,
	"button": `productList_button__p9Yfl`,
	"proxy_container": `productList_proxy_container__PaBn4`,
	"freeDateLabel": `productList_freeDateLabel__AJ2-0`,
	"expiredLabel": `productList_expiredLabel__bXpXT`,
	"topUp": `productList_topUp__xN3Jd`,
	"buttons": `productList_buttons__Xj-Z5`,
	"view": `productList_view__JuOk+`,
	"reset": `productList_reset__sn58y`,
	"download": `productList_download__dH+JE`,
	"proxy_option": `productList_proxy_option__LoU2q`,
	"proxy_list": `productList_proxy_list__co6-B`,
	"mobile": `productList_mobile__yzJEA`,
	"productCardContainer": `productList_productCardContainer__hviYU`,
	"productCard": `productList_productCard__E55pW`,
	"product_head": `productList_product_head__1M8eI`,
	"product_headLabel": `productList_product_headLabel__CY5qz`,
	"product_name": `productList_product_name__E-y0X`,
	"quantity": `productList_quantity__WSDh0`,
	"quantity_No": `productList_quantity_No__jaWZI`,
	"right": `productList_right__xf0it`,
	"day_label": `productList_day_label__BCUhr`,
	"expired_label": `productList_expired_label__HaArR`,
	"white": `productList_white__bBGy3`,
	"marginRight": `productList_marginRight__85OZP`,
	"day": `productList_day__Zv3Ms`,
	"location": `productList_location__0+9v5`,
	"Data": `productList_Data__-qICP`,
	"LowData": `productList_LowData__Nf4MZ`,
	"HighData": `productList_HighData__O1oJ9`,
	"ProductName": `productList_ProductName__v3oPR`,
	"ProductType": `productList_ProductType__CfYO9`,
	"proxy": `productList_proxy__3RMCX`,
	"proxy_ref": `productList_proxy_ref__EKAJd`,
	"desktop": `productList_desktop__qvw+E`,
	"container": `productList_container__Dm7YI`,
	"brand": `productList_brand__DLBrJ`,
	"lab": `productList_lab__euy7q`,
	"labList": `productList_labList__JZkHf`,
	"labItem": `productList_labItem__F4KV1`,
	"moreItemText": `productList_moreItemText__ego2g`,
	"from": `productList_from__FwZiQ`,
	"labInfo": `productList_labInfo__tGITV`,
	"logo": `productList_logo__0tvQf`,
	"paymentLabel": `productList_paymentLabel__zFX7g`
};
export default ___CSS_LOADER_EXPORT___;
